(() => {
  const POST_MESSAGE_TYPE = 'libraryMainsite-t-article:ok';

  function postOkToParent() {
    try {
      // iframe -> parent so parent can close popup or continue flow
      window.parent?.postMessage(
        {
          type: POST_MESSAGE_TYPE,
          action: 'ok',
          source: 'article',
        },
        '*',
      );
    } catch (_) {
      // ignore
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const btnOk = document.querySelector('.btn_ok');
    if (!btnOk) return;

    btnOk.addEventListener('click', (e) => {
      e.preventDefault();
      postOkToParent();
    });
  });
})();

